module.exports = __webpack_public_path__ + "static/media/baso.cc1bc9a7.png";